/**
 * Statsig user object builder (Track B4). Tested via snapshot for tenant targeting.
 */
export type StatsigUserInput = {
    id?: string;
    email?: string;
    tenantId?: string | null;
};

export function toStatsigUser(user: StatsigUserInput | null) {
    const userID = user?.id ?? user?.email ?? "anonymous";
    const customIDs =
        user?.tenantId != null && user.tenantId !== ""
            ? { tenantID: user.tenantId }
            : undefined;

    return {
        userID,
        email: user?.email || undefined,
        ...(customIDs ? { customIDs } : {}),
    };
}
